export default () => ({
    opened: false,
    scrolled: false,
    init() {
      const _this = this;
      if (this.$refs.main) {
        this.scrolled = pageYOffset > this.$refs.main.clientHeight;
        window.addEventListener('scroll', () => this.scrolled = pageYOffset > this.$refs.main.clientHeight);
      }
    }
})